/** @module Enums */ /** typedoc */

export enum InternalErrorEnum {
    nonNullExpected = -1001
}
